import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { StoreContext } from 'storeon/react';

import './base-index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import 'react-datepicker/dist/react-datepicker.css';

import App from './components/App/App';
import NotFound from './components/NotFound/NotFound';
import reportWebVitals from './reportWebVitals';
import { config } from './state/config';
import { store } from './state/store';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename={config.publicUrl}>
      <StoreContext.Provider value={store}>
        <Switch>
          <Route path="/">
            <App />
          </Route>
          <Route>
            <NotFound />
          </Route>
        </Switch>
      </StoreContext.Provider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
